import React from 'react';
import {useTranslation} from "react-i18next";

const HomeInclude = () => {
  const {t} = useTranslation();
  const lang = (key) => t(`webApplicationDevelopmentPage.${key}`);
  return (
    <div>
      {/* HERO SECTION */}
      <section className="flex items-center rounded-xl mt-10 bg-gradient-to-r from-zinc-600 via-theme-color to-gray-800 text-white px-6 lg:px-20 py-14">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-6">
              {t('common.webApplicationDevelopment')}
            </h1>
            <p className="text-lg lg:text-xl text-gray-200 mb-8">
              {lang('weBuild')}
            </p>
          </div>
          <img
            src="https://images.unsplash.com/photo-1555066931-4365d14bab8c"
            alt={t('common.webApplicationDevelopment')}
            className="rounded-2xl shadow-2xl"
          />
        </div>
      </section>
      {/* ABOUT OUR APPROACH */}
      <section className="py-28 px-6 lg:px-20 bg-gray-50 text-black rounded-xl mt-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <img
            src="https://images.unsplash.com/photo-1551434678-e076c223a692"
            alt="Team Working"
            className="rounded-2xl shadow-xl"
          />
          <div>
            <h2 className="text-4xl font-bold mb-6">{lang('howWeBuildModern')}</h2>
            <p className="text-lg text-gray-600 mb-6">{lang('howWecombine')}</p>
            <ul className="space-y-4">
              <li>✔ {lang('requirementAnalysis')}</li>
              <li>✔ {lang('uiUxDesign')}</li>
              <li>✔ {lang('frontBack')}</li>
              <li>✔ {lang('securityPerformance')}</li>
              <li>✔ {lang('deploymentOngoing')}</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeInclude;
